import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { map, catchError } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppState } from '../../services/app.service';
import { UserService } from '../../dataServices/userService';
import { PdfReportService } from "../../services/pdfReport.service";
import { User } from '../../models/user';

@Component({
    selector: 'self-ins-coverage-proposal',
    templateUrl: './coverage-proposal-page.component.html',
    styleUrls: ['./coverage-proposal-page.component.scss'],
    standalone: false
})

export class CoverageProposalPageComponent {
    public headerText: string = '';
    public user!: User;
    public pdfContent: Uint8Array | null = null;
    public hasError: boolean = false;
    public isLoading: boolean = true;
    public qnum = 0;
    public qsuffix = '';
    
    constructor(private appState: AppState,
                private activeRouter: ActivatedRoute,
                private router: Router,
                private userStatusService: UserService,
                private pdfReportService: PdfReportService,
                private translate: TranslateService,
                public _translateService: TranslateHelperService) {
        this.user = this.appState.user.getValue();
        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        });
        const headerKey = this.user?.status === 'active' ? this._translateService.Keys.COVERAGE_PROPOSAL_TITLE_ACTIVE : this._translateService.Keys.COVERAGE_PROPOSAL_TITLE_INACTIVE;
        this._translateService.translateAsync(headerKey).subscribe((text: string) => {
            this.headerText = text;
        });
        this.pdfReportService.getProposalPdf(this.qnum, this.qsuffix)
            .pipe(
                map((r) => r.content),
                catchError((error) => {
                    console.error('Error loading PDF:', error);
                    this.hasError = true;
                    return of(null);
                }),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe((content) => {
                if (content) {
                    this.pdfContent = new Uint8Array(content as ArrayBuffer);
                }
            });
    }

    public enroll() {
        this.userStatusService.enroll().subscribe(() => {
            this.appState.updateUser({
                ...this.appState.user.getValue(),
                status: 'active'
            });
            this.router.navigate(['/enrollment-confirmation']);
        })
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}
